import Axios from "axios";
import { toast } from "react-toastify";
import { signoutUser } from "../actions/UserActions";

class AxiosWrapper {
  callCancel = null;
  reduxStore = null;

  constructor() {
    this.callCancel = Axios.CancelToken.source();
  }

  redirectToLogin = (message, error) => {
    this.callCancel.cancel("Cancel");
    signoutUser();
    this.callCancel = Axios.CancelToken.source();
    return Promise.reject(error);
  };

  handleSuccess = (response) => {
    if (response.data.isSuccessful === undefined) return response.data;

    if (response.data.isSuccessful) {
      return response.data.response;
    } else {
      response.data.errors.forEach((a) => {
        toast.error(a);
      });
      return Promise.reject(response.data);
    }
  };

  axiosInstance = () => {
    const axiosInstance = Axios.create({
      headers: {
        Authorization: "bearer " + localStorage.getItem("token"),
        Pragma: "no-cache",
      },
      cancelToken: this.callCancel.token,
    });

    const interceptor = axiosInstance.interceptors.response.use(
      this.handleSuccess,
      (error) => {
        if (error.message === "Cancel") {
          return Promise.reject(error);
          // } else if (!error.response) {
          //   return this.redirectToLogin("Connection error", error);
        } else if (error.response.status === 401) {
          return this.redirectToLogin("Unauthorized", error);
        } else if (error.response.status === 403) {
          return Promise.reject(error);
        } else if (error.response.status === 413) {
          return Promise.reject({ status: 413 });
        } else if (error.response.status <= 400) {
          let keys = Object.getOwnPropertyNames(error.response.data.errors);
          keys.map((key) => toast.error(error.response.data.errors[key][0]));
          return Promise.reject(error);
        } else if (error.response.status === 500) {
          if (error.response.data !== "") {
            if (error.response.data.error !== undefined) {
              toast.error(error.response.data.error[0]);
            } else {
              toast.error(error.response.statusText);
            }
          } else {
            toast.error(error.response.statusText);
          }
          return Promise.reject(error);
        }
        axiosInstance.interceptors.response.eject(interceptor);
      }
    );

    return axiosInstance;
  };

  AxiosPost = (url, data, config = {}) => {
    return this.axiosInstance().post(url, data, config);
  };

  AxiosGet = (url, config) => {
    return this.axiosInstance().get(url, config);
  };
}

const WrapperSingleton = new AxiosWrapper();

export default WrapperSingleton;

export const AxiosPost = WrapperSingleton.AxiosPost;
export const AxiosGet = WrapperSingleton.AxiosGet;
